import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { type BidStateFilter } from '../domain/RfpSummary'
import { ProposalRepository } from '../infra/ProposalRepository'

export type GetRfpHistoryFactoryDependencies = {
  repository: ProposalRepository
}

export type GetPaginatedRfpHistoryParams = {
  bidState?: BidStateFilter
  page?: number
}

export function getPaginatedRfpHistoryFactory({ repository }: GetRfpHistoryFactoryDependencies) {
  return async function get(
    params: GetPaginatedRfpHistoryParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await repository.getPaginatedRfpHistory({
        ...params,
        config,
      })
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not get paginated RFP history', { cause: error as Error })
    }
  }
}

export function getPaginatedRfpHistory(
  params: GetPaginatedRfpHistoryParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new HttpClient(API_URL)
  const repository = new ProposalRepository({ httpClient })
  const get = getPaginatedRfpHistoryFactory({ repository })
  return get(params, config)
}
